import { render, staticRenderFns } from "./user-info.vue?vue&type=template&id=31e0982f&scoped=true"
import script from "./user-info.vue?vue&type=script&lang=js"
export * from "./user-info.vue?vue&type=script&lang=js"
import style0 from "./user-info.vue?vue&type=style&index=0&id=31e0982f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e0982f",
  null
  
)

export default component.exports